"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadDocumentAPI = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const url_1 = require("../../../util/url");
const useUploadDocumentAPI = (entityID) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    const uri = `/shipments/${entityID}/documents?jwt=${token}`;
    const url = (0, url_1.getAPIUrl)(uri, config.SHIPPING_ENDPOINT);
    const uploadDocument = async (file, role) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('role', role);
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const data = await response.json();
        return data;
    };
    return {
        uploadDocument,
    };
};
exports.useUploadDocumentAPI = useUploadDocumentAPI;
//# sourceMappingURL=uploadDocument.js.map